import * as React from 'react';
import { IRecordedDeed } from '../classes/RecordedDeed';
import { IRecordedMortgageRequired, IRecordedMortgage } from '../classes/RecordedMortgage';
import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';
import { FormCell, Grid, BodyText, Header2Text, GridItem } from 'ui-toolkit';
import getText from '../utils/getText';
import RecordedMortgageDetails from './RecordedMortgageDetails';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';
import GrayLine from '../../components/shared/GrayLine';

interface IAmericanDigitalDetails {
  recordedDeed: IRecordedDeed;
  recordedMortgage: IRecordedMortgage;
  policyType: PolicyTypeEnum;
  transactionType: eTransactionCategory;
  vestedIn: string | null;
  userData: IRecordedMortgage;
  requiredFields: IRecordedMortgageRequired;
  onRecordedMortgageChange: (value: IRecordedMortgage, propName: string, error?: string | null) => void;
  errorRecordedMortgage: any;
  onUpdateDocument: () => void;
  onCancelClick: () => void;
  showSaveSpinner: boolean;
  showSaveSuccess: boolean;
  updateErrorText: string | null;
  recordedMortgageWasChanged: boolean;
}

export const AmericanDigitalDetails: React.FC<IAmericanDigitalDetails> = (props) => (
  <Grid columnCount={2}>
    {props.policyType === PolicyTypeEnum.owner ? (
      <>
        <FormCell label={'Grantee(s)'}>{props.recordedDeed.grantee || 'None'}</FormCell>
        <FormCell label={'Grantor(s)'}>{props.recordedDeed.grantor || 'None'}</FormCell>
      </>
    ) : props.transactionType === eTransactionCategory.Purchase ? (
      <>
        <FormCell label={'Grantee/Mortgagor'}>{props.recordedDeed.grantee || 'None'}</FormCell>
        <FormCell label={'Grantor(s)'}>{props.recordedDeed.grantor || 'None'}</FormCell>
      </>
    ) : (
      <>
        <FormCell label={'Mortgagor'}>{props.userData.mortgagor_name || 'None'}</FormCell>
        <GridItem columnStart={1} columnEnd={3}>
          <Header2Text>{getText('recordedDeed.existing')}</Header2Text>
          <BodyText>{props.vestedIn || ''}</BodyText>
        </GridItem>
        <GrayLine />
        <GridItem columnStart={1} columnEnd={3}>
          <RecordedMortgageDetails
            data={props.recordedMortgage}
            title={getText('recordedMortgage.new')}
            modalWindowTitle={getText('recordedMortgage.editNew')}
            userData={props.userData}
            requiredFields={props.requiredFields}
            onRecordedMortgageChange={props.onRecordedMortgageChange}
            errorRecordedMortgage={props.errorRecordedMortgage}
            onUpdateDocument={props.onUpdateDocument}
            onCancelClick={props.onCancelClick}
            showSaveSpinner={props.showSaveSpinner}
            showSaveSuccess={props.showSaveSuccess}
            updateErrorText={props.updateErrorText}
            recordedMortgageWasChanged={props.recordedMortgageWasChanged}
          />
        </GridItem>
      </>
    )}
  </Grid>
);
